import { defaultDictionary } from './chunk-4DPTK2CR.js';

// src/internal/i18n/resolveTranslator.ts
var PARAM_RE = /\{(\w+)\}/g;
function resolveTranslator(input) {
  if (typeof input === "function") return input;
  const dict = { ...defaultDictionary, ...input ?? {} };
  return (key, params) => {
    const tpl = dict[key] ?? key;
    if (!params) return tpl;
    return tpl.replace(
      PARAM_RE,
      (_, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : `{${name}}`
    );
  };
}

export { resolveTranslator };
//# sourceMappingURL=chunk-RRFUPILC.js.map
//# sourceMappingURL=chunk-RRFUPILC.js.map